import { render, staticRenderFns } from "./ProblemPage.vue?vue&type=template&id=4382559a"
import script from "./ProblemPage.vue?vue&type=script&lang=ts"
export * from "./ProblemPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports